export default __webpack_public_path__ + "static/media/wallpaper_02.8f382a83.jpg";